export { StarRating } from '../src/StarRating';
